<style lang="scss" scoped>
.tab-panels {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;

    @media screen and (min-width: 768px) {
        flex-direction: row;
    }

    .tabs {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        margin-bottom: 40px;

        @media screen and (min-width: 768px) {
            width: 30%;
            padding-right: 16px;
            margin-bottom: 0;
        }

        a {
            margin-bottom: 24px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 1.5rem;

            &.active {
                color: #26a039;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .content {
        width: 100%;

        @media screen and (min-width: 768px) {
            width: 70%;
        }
    }

    .component-fade-enter-active,
    .component-fade-leave-active {
        transition: opacity 0.15s ease;
    }
    .component-fade-enter,
    .component-fade-leave-to {
        opacity: 0;
    }
}
</style>

<template>
    <div class="tab-panels" ref="tabpanels">
        <div class="tabs">
            <a href="#" :class="{active: (index === activeIndex)}" v-for="(tab, index) in tabData" @click.prevent="activeIndex = index" :key="index" v-html="tab.title"></a>
        </div>
        <transition name="component-fade" mode="out-in">
            <div class="content" :key="activeIndex">
                <h4 class="mb-16" v-html="tabData[activeIndex].title"></h4>
                <div class="wysiwyg text-14 text-blue opacity-70" v-html="tabData[activeIndex].content"></div>
            </div>
        </transition>
    </div>
</template>

<script>
var slugify = require('slugify')
const scrollIntoView = require('scroll-into-view');

export default {
    name: "Ui.TabPanels",

    data: () => {
        return {
            activeIndex: 0
        }
    },

    mounted() {
        const self = this;

        if (window.location.hash) self.hashUpdate(window.location.hash);

        function locationHashChanged() {
            self.hashUpdate(location.hash, true)
        }

        window.onhashchange = locationHashChanged;
    },

    methods: {
        hashUpdate(hash, animate = false) {
            let index = this.tabData.findIndex((t) => {
                return hash === `#${slugify(t.title, { lower: true })}`;
            });

            if (index >= 0) {
                this.activeIndex = index;

                if (animate) {
                    const headerHeight = document.getElementsByTagName('header').length > 0 ? document.getElementsByTagName('header')[0].clientHeight : 0;
                    const topOffset = window.innerWidth < 767.98 ? headerHeight + 56 : headerHeight + 40;
                    const scrollOptions = {
                        align: {
                            top: 0,
                            topOffset: topOffset
                        },
                    }

                    scrollIntoView(this.$refs.tabpanels, scrollOptions);
                }
            }
        }
    },

    props: {
        tabData: {
            type: Array,
            required: true
        }
    }
}
</script>